<template>
    <div class="bg-img-container h-100">
        <v-container fluid>

            <v-row class="mx-10 mt-6">

                <v-col md="5" order-md="1">
                    <v-card elevation="5">
                        <v-toolbar style="background-color: #0d2155;" role="banner">
                            <v-container fluid class="text-center">
                                <v-toolbar-title class="text-white">
                                    <LanguagePlaceholder
                                        default-text="Login" />
                                </v-toolbar-title>
                            </v-container>
                        </v-toolbar>

                        <v-card-text>
                            <v-window v-model="loginWindow">
                                <v-window-item value="enter-credentials">

                                    <v-text-field ref="test" v-model="username" prepend-inner-icon="mdi-email-outline"
                                        class="mt-2" variant="outlined" density="comfortable"
                                        aria-label="Username - Business email address" type="email" autocomplete="username">
                                        <template v-slot:label>
                                            <LanguagePlaceholder 
                                                :element-visible="loginWindow == 'enter-credentials'"
                                                default-text="Username (Business email address)" />
                                        </template>
                                    </v-text-field>
                                    <v-text-field v-model="password" prepend-inner-icon="mdi-lock-outline"
                                        :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append-inner="showPassword = !showPassword"
                                        :type="showPassword ? 'text' : 'password'" variant="outlined"
                                        density="comfortable" 
                                        aria-label="Password" autocomplete="current-password"
                                        :aria-description="showPassword ? 'Password is visible' : 'Password is hidden'">
                                        <template v-slot:label>
                                            <LanguagePlaceholder
                                                default-text="Password"
                                                :element-visible="loginWindow == 'enter-credentials'" />
                                        </template>
                                    </v-text-field>
                                    <v-btn class="text-none mt-4" @click="clickLogin"
                                        :disabled="username.trim().length < 3 || password.trim().length < 3"
                                        color="#2a6fc3" size="large" variant="elevated" block>
                                        <LanguagePlaceholder 
                                            :element-visible="loginWindow == 'enter-credentials'"
                                            default-text="Partner and Distributor Login" />
                                    </v-btn>
                                    <v-btn @click="clickForgotPassword" class="my-2 text-none" color="#0672CB"
                                        size="large" variant="outlined" block>
                                        <LanguagePlaceholder
                                            default-text="Forgotten Password?"
                                            :element-visible="loginWindow == 'enter-credentials'" />
                                    </v-btn>
                                    <hr class="my-4" style="width:60%;margin-left: auto;margin-right:auto;">
                                    <OktaSignIn />
                                </v-window-item>
                                <v-window-item value="create-password">
                                    <p class="general-text">
                                        First login, please create a new password
                                    </p>
                                    <PasswordStrength class="mt-2" v-model="newPassword" :min-characters="12"
                                        @passwordValidated="passwordValidated" inner-icon="mdi-lock-outline"
                                        place-holder="Enter your password" />
                                    <v-btn class="text-none" :disabled="!passwordsValidated"
                                        @click="clickSubmitCreatePassword" color="#2a6fc3" size="large"
                                        variant="elevated" block>
                                        <LanguagePlaceholder 
                                            default-text="Submit" :element-visible="loginWindow == 'create-password'" />
                                    </v-btn>
                                </v-window-item>
                                <v-window-item value="enter-otp">
                                    <v-card>
                                        <v-card-title>
                                            <LanguagePlaceholder
                                                default-text="Please enter 6 digit OTP"
                                                :element-visible="loginWindow == 'enter-otp'" />
                                        </v-card-title>
                                        <v-card-text class="pb-0">

                                            <p>
                                                <v-otp-input autofocus v-model="otpInput" focus-all @finish="otpFinish"
                                                    :length="6" aria-label="Enter 6 digit One Time Password"></v-otp-input>
                                            </p>
                                            <p class="mb-4 text-medium-emphasis text-body-2">
                                                <LanguagePlaceholder v-if="qrBase64.length > 0"
                                                    default-text="Scan the QR Code to login using Microsoft Authenticator instead." />
                                            </p>
                                            <p class="text-center">
                                                <img v-if="qrBase64.length > 0" height="150" width="150"
                                                    :src="qrBase64" alt="QR Code for Microsoft Authenticator setup" />
                                            </p>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="text-none" @click="cancelLogin" width="100" block
                                                variant="tonal">
                                                <LanguagePlaceholder 
                                                    default-text="Cancel"
                                                    :element-visible="loginWindow == 'enter-otp'" />
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-window-item>
                                <v-window-item value="enter-otp-first-login">
                                    <v-card>
                                        <v-card-title>
                                            <LanguagePlaceholder
                                                default-text="Please enter the 6 digit OTP that was sent to"
                                                :element-visible="loginWindow == 'enter-otp-first-login'" />
                                            {{ username }}
                                        </v-card-title>
                                        <v-card-text>
                                            <div>
                                                <v-otp-input autofocus v-model="otpInput" focus-all
                                                    @finish="otpFinishFirstLogin" :length="6" aria-label="Enter 6 digit One Time Password sent to your email"></v-otp-input>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="text-none" @click="cancelLogin" width="100" block
                                                variant="tonal">
                                                <LanguagePlaceholder
                                                    default-text="Cancel"
                                                    :element-visible="loginWindow == 'enter-otp-first-login'" />
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-window-item>
                            </v-window>
                        </v-card-text>
                    </v-card>
                    <v-card class="mt-10" elevation="5">
                            <v-toolbar style="background-color: #0d2155;" role="banner">
                            <v-container fluid class="text-center">
                                <v-toolbar-title class="text-white">
                                    <LanguagePlaceholder
                                        default-text="Register For RISE" />
                                </v-toolbar-title>
                            </v-container>

                        </v-toolbar>

                        <v-card-text>
                            <p>
                                <v-btn class="text-none" @click="systemStore.routerTo('registration')" color="#2a6fc3"
                                    size="large" type="submit" variant="elevated" block>
                                    <LanguagePlaceholder 
                                        default-text="Register Now" />
                                </v-btn>
                            </p>
                            <p class="general-text mt-6">
                                <LanguagePlaceholder @custom-event="triggerCustomEvent"
                                    is-html
                                    default-text="If you need help registering for RISE," />
                                <LanguagePlaceholder @custom-event="triggerCustomEvent"
                                    is-html
                                    default-text="<custom-event action='showRISEVideo' class='blue-link body-bold'> watch this video </custom-event>" />
                                <LanguagePlaceholder @custom-event="triggerCustomEvent"
                                    is-html
                                    default-text="for a step-by-step guide." />
                            </p>
                            <p class="general-text mt-6">
                                <LanguagePlaceholder is-html
                                    default-text="Trouble registering? Contact" />
                                <a href='mailto:support@dellpartnerincentives.com'> support@dellpartnerincentives.com</a>
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col md="7" order-md="0" elevation="5">
                    <v-card align-self="end">
                        <v-toolbar style="background-color: #0d2155;" role="banner">

                            <v-toolbar-title class="text-white">
                                <img style="min-width: 315px; position: absolute; margin-top: -10px;" class=""
                                    width="315" height="25" src="../img/partner-dell-white.png" alt="Dell Technologies Partner Program Logo" />
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn color="white" class="text-none" aria-label="Change Language">
                                <LanguagePlaceholder
                                    default-text="Change Language" />
                                <v-menu activator="parent" transition="scale-transition" location="bottom" aria-label="Language selection menu">
                                    <v-list role="menu">
                                        <v-list-item v-for="(item, index) in systemStore.getData('languages')"
                                            :key="index" :value="index" @click="selectLanguage(item)" role="menuitem">
                                            <v-list-item-title>{{ item.language }}</v-list-item-title>
                                        </v-list-item>                                        
                                    </v-list>
                                </v-menu>
                            </v-btn>



                        </v-toolbar>
                        <v-card-text>
                                <!-- <video width="600" height="338" controls preload="none"
                                    poster="https://dellpartnerincentives.com/siteassets/WelcomeToRiseVideo/welcome-to-rise-poster.png">
                                    <source
                                        src="https://dellpartnerincentives.com/siteassets/WelcomeToRiseVideo/735114 Dell - RISE - Existing Partners Welcome ENG.mp4"
                                        type="video/mp4">
                                    Your browser does not support the video tag.
                                </video> -->

                                    <v-row style="padding:43% 0 0 0;position:relative;">
                                        <iframe :src="vimeoEmbedSrc"
                                        frameborder="0" 
                                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
                                        style="position:absolute;top:0;left:0;width:100%;height:90%;" 
                                        title="Welcome To RISE - Introduction video for the RISE Partner Incentive Program"
                                        aria-label="Welcome To RISE video player"></iframe>
                                    </v-row>
              

                                <!-- <iframe
                                    src="https://dellpartnerincentives.com/siteassets/WelcomeToRiseVideo/735114 Dell - RISE - Existing Partners (Welcome) (ENG).mp4"
                                    width="600" height="338" frameborder="0"
                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                    title="Introduction to RISE"></iframe> -->
                                <!-- <iframe
                                    src="https://player.vimeo.com/video/931999214?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                    width="600" height="338" frameborder="0"
                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                    title="Introduction to RISE"></iframe> -->
                        <v-row class="ma-4">
                            <p class="general-heading">
                                <LanguagePlaceholder 
                                    default-text="Buy More, Earn More – With RISE" />
                            </p>
                            <p class="general-text mt-6">
                                <LanguagePlaceholder 
                                    default-text="If you are a Dell Technologies Authorized Tier Partner, you can earn generous dollar rewards every time you purchase eligible products through Distribution." />
                            </p>
                            <p class="general-text mt-4">
                                <a class='general-link'
                                    href='https://www.dellpartnerincentives.com/files/Acquisitions/Partner%20Presentation/RISE%20Partner%20Introductory%20Guide%20EN.pdf'
                                    target="_blank">
                                    <LanguagePlaceholder  is-html
                                        default-text="Click here to learn more about the RISE Incentive Program" />
                                </a>
                            </p>
                            <p class="general-text mt-2">
                                <a class='general-link'
                                    href='https://www.delltechnologies.com/partner/en-gb/partner/partner.htm'
                                    target="_blank">
                                    <LanguagePlaceholder  is-html
                                        default-text="Click here if you would like to become a Dell Technologies Authorized Partner" />
                                </a>
                            </p>

                        </v-row>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>



        </v-container>



        <v-footer height="45" color="#212529" padless app role="contentinfo">
            <v-row justify="center" no-gutters>
                <ul class="navigation-list" role="list" aria-label="Footer navigation menu">
                    <li>
                        <v-btn variant="text" @click="systemStore.routerTo('noauth-terms-of-use')"
                            class="my-2 mx-2 text-white text-none" aria-label="Terms Of Use" @keydown.enter="systemStore.routerTo('noauth-terms-of-use')" @keydown.space.prevent="systemStore.routerTo('noauth-terms-of-use')" tabindex="0" role="link">
                            <LanguagePlaceholder  is-html position="fixed"
                                default-text="Terms Of Use" />
                        </v-btn>
                    </li>
                    <li>
                        <v-btn variant="text" @click="systemStore.routerTo('noauth-privacy-statement')"
                            class="my-2 mx-2 text-white text-none" aria-label="Privacy Statement" @keydown.enter="systemStore.routerTo('noauth-privacy-statement')" @keydown.space.prevent="systemStore.routerTo('noauth-privacy-statement')" tabindex="0" role="link">
                            <LanguagePlaceholder  is-html position="fixed"
                                default-text="Privacy Statement" />
                        </v-btn>
                    </li>
                    <li>
                        <v-btn variant="text" @click="systemStore.routerTo('noauth-cookies-information')"
                            class="my-2 mx-2 text-white text-none" aria-label="Cookies Information" @keydown.enter="systemStore.routerTo('noauth-cookies-information')" @keydown.space.prevent="systemStore.routerTo('noauth-cookies-information')" tabindex="0" role="link">
                            <LanguagePlaceholder is-html position="fixed"
                                default-text="Cookies Information" />
                        </v-btn>
                    </li>
                </ul>
            </v-row>
        </v-footer>

        <v-dialog persistent v-model="showVideo" width="650" role="dialog" aria-labelledby="video-dialog-title">
            <v-card width="650">
                <v-card-title id="video-dialog-title">How To Register Video</v-card-title>
                <v-card-text>
                    
                    <!-- <video width="600" height="338" controls preload="none"
                        poster="https://dellpartnerincentives.com/siteassets/WelcomeToRiseVideo/welcome-to-rise-poster.png"
                        aria-label="Welcome to RISE Partner Program video">
                        <source
                            src="https://dellpartnerincentives.com/comms/RISE Assets/Videos/Welcome to RISE /Welcome to RISE_EN.mp4"
                            type="video/mp4">
                        <source
                            src="https://dellpartnerincentives.com/siteassets/WelcomeToRiseVideo/735114 Dell - RISE - Existing Partners (Welcome) (ENG).mp4"
                            type="video/mp4">
                        Your browser does not support the video tag.
                    </video> -->

                    <v-row style="padding:60% 0 0 0;position:relative;">
                        <iframe width="600" height="338" controls preload="none" 
                        :src="RegisterVideo"
                        frameborder="0" 
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
                        style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                        title="Welcome To RISE - Introduction video for the RISE Partner Incentive Program"
                        aria-label="Welcome To RISE video player"></iframe>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showVideo = false" aria-label="Close video dialog">
                        <LanguagePlaceholder default-text="Close" />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>




</template>

<script setup>
import router from '../router'
import { computed, ref, onMounted, resolveComponent } from 'vue'
import { useRoute } from 'vue-router'
import md5 from 'blueimp-md5'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import PasswordStrength from '@/components/PasswordStrength.vue'
import PrivacyStatement from '@/components/PrivacyStatement.vue'
import OktaSignIn from '@/components/OktaSignIn.vue'

import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'
import { json2csv } from 'json-2-csv'

// import {authService} from '@/services/auth';

const test = ref(true)
const playWelcome = ref(false)

const showVideo = ref(false);
const loginWindow = ref('enter-credentials')
const showPassword = ref(false)

const systemStore = useSystemStore()
const authStore = useAuthStore()
const route = useRoute()
const refr = ref('')

const VIMEO_PLAYER_QUERY =
    'title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'

// Map ISO language codes (lowercase) to Vimeo video IDs.
// Fallback behavior: if a language isn't mapped, use English.
const vimeoVideoIdByLanguage = Object.freeze({
    en: '1174417709',
    // fr: 'PUT_FRENCH_VIDEO_ID_HERE',
    de: '1174423704',
    es: '1174423791',
    it: '1174423876',
    pl: '1174423961',
    tr: '1174424049',
})

const vimeoEmbedSrc = computed(() => {
    const lang = (systemStore.selectedLanguage || '').toString().toLowerCase()
    const videoId = vimeoVideoIdByLanguage[lang] || vimeoVideoIdByLanguage.en
    return `https://player.vimeo.com/video/${videoId}?${VIMEO_PLAYER_QUERY}`
})

const RegisterVideo = computed(() => {
    const videoId = '1072138455'
    return `https://player.vimeo.com/video/${videoId}`
})

onMounted(() => {
    console.log('DEBUG: LoginView mounted');
    console.log('DEBUG: Current URL:', window.location.href);
    console.log('DEBUG: Route query params:', route.query);
    
    // Check if we have Okta callback parameters in the URL
    if (route.query.code || route.query.error) {
        console.log('WARNING: Okta callback parameters found on login page!');
        console.log('DEBUG: This suggests Okta redirected to login instead of /auth/callback');
        console.log('DEBUG: Auth code present:', !!route.query.code);
        console.log('DEBUG: Error present:', !!route.query.error);
        if (route.query.error) {
            console.log('ERROR: Okta error:', route.query.error, route.query.error_description);
        }
    }

    username.value = import.meta.env.VITE_UN;
    password.value = import.meta.env.VITE_PWD;

    if (route.query.dl != undefined && route.query.dl.length > 0){
        systemStore.selectedLanguage = route.query.dl.toLowerCase()
        localStorage.setItem("selectedLanguage", systemStore.selectedLanguage)
    }
})

const username = ref('')
const password = ref('')

const loginSuccess = ref(false)
const newPassword = ref('')
const otpSuccess = ref(false)
const otpInput = ref('')
const qrBase64 = ref('')
const passwordsValidated = ref(false)
const isMigratedUserFirstLogin = ref(false)
const forgotPasswordUsername = ref('')


// const languageItems = [
//     { title: 'Français', language: 'FRANCAIS', code: 'FR', videoId: '' },
//     { title: 'Deutsch', language: 'DEUTSCH', code: 'DE', videoId: ''  },
//     { title: 'Español', language: 'ESPANOL', code: 'ES', videoId: ''  },
//     { title: 'Italiano', language: 'ITALIANO', code: 'IT', videoId: ''  },
//     { title: 'English', language: 'ENGLISH', code: 'EN', videoId: '1174417709'  },
//     { title: 'Polski', language: 'POLSKI', code: 'PL', videoId: ''  },
//     { title: 'Türkçe', language: 'TURKISH', code: 'TR', videoId: ''  },
// ]

const icons = [
    'mdi-home',
    'mdi-email',
    'mdi-calendar',
    'mdi-delete'
]

const triggerCustomEvent = (action) => {
    if (action == 'showRISEVideo') {
        showVideo.value = true
    }
}

const clickSubmitCreatePassword = () => {
    authStore.sendEmailVerificationOtp(username.value).then(res => {
        if (res.success == true) {
            loginWindow.value = 'enter-otp-first-login'
        } else {
            // show error message
        }
    })

}


const passwordValidated = (validated) => {
    passwordsValidated.value = validated
}

const clickForgotPassword = () => {
    router.push({ name: 'forgot-password' })
}

const clickLogin = () => {
    authStore.isFirstLogin(username.value).then(res => {
        if (res == true) {
            isMigratedUserFirstLogin.value = true
            loginWindow.value = 'create-password'
        } else {
            // IF NOT A FIRST LOGIN BY MIGRATED USER, THEN LOGIN AS USUAL 
            authStore.login(username.value, password.value).then(res => {
                if (res.success == true) {
                    loginSuccess.value = true

                    var tk = sessionStorage.getItem("accessToken");
                    var pli = tk.split('.')[1];
                    var pl = JSON.parse(atob(pli.replace(/-/g, "+").replace(/_/g, "/")))
                    refr.value = md5(pl.SID + '_true');

                    authStore.sendOtpEmail().then(res => {
                        if (res.success == true) {
                            loginWindow.value = 'enter-otp'

                            // Only fetch QR code when TOTP is NOT enabled for the user.
                            const totpEnabledRaw =
                                systemStore.userDetail?.IsTotpEnabled ?? systemStore.userDetail?.isTotpEnabled

                            const totpEnabled =
                                totpEnabledRaw === true ||
                                totpEnabledRaw === 1 ||
                                totpEnabledRaw === '1' ||
                                (typeof totpEnabledRaw === 'string' && totpEnabledRaw.toLowerCase() === 'true')

                            if (!totpEnabled) {
                                authStore.getTotpQrCode().then(res => {
                                qrBase64.value = 'data:image/jpeg;charset=utf-8;base64,' + res.qrCodeBase64
                            })
                            }
                        }
                    })
                } else {
                    loginSuccess.value = false
                }
            }).catch(error => {
                console.log(error.response.data)
            })
        }
    }).catch(error => {
        console.log(error)
    })


}

const otpFinish = () => {
    verifyOtp().then(res => {
        otpSuccess.value = res.success

        // if (loginSuccess.value === true && otpSuccess.value === true) {
        if (loginSuccess.value === true && otpSuccess.value === true && res.ref == refr.value.toLowerCase()) {
            authStore.userAuthorized = true
            if (systemStore.userDetail.userType.trim() == 'Partner') {
                if (systemStore.requestedRoute.trim().length > 0) {
                    router.push({ name: systemStore.requestedRoute })
                } else {
                    router.push({ name: 'home-partner' })
                }
            } else if (systemStore.userDetail.userType.trim() == 'Distributor') {
                if (systemStore.requestedRoute.trim().length > 0) {
                    router.push({ name: systemStore.requestedRoute })
                } else {
                    router.push({ name: 'home-distributor' })
                }
            }
            else if (systemStore.userDetail.userType.trim() == 'Dell'
                || systemStore.userDetail.userType.trim() == 'TP'
                || systemStore.userDetail.userType.trim() == 'PAM'
                || systemStore.userDetail.userType.trim() == 'Dell Marketing'
                || systemStore.userDetail.userType.trim() == 'Dell'
                || systemStore.userDetail.userType.trim() == 'TIC_Admin') {
                if (systemStore.requestedRoute.trim().length > 0) {
                    router.push({ name: systemStore.requestedRoute })
                } else {
                    router.push({ name: 'home-partner' })
                }
            }
        } else {
            otpInput.value = ''
            systemStore.showMessage('Invalid OTP Entered.', {color:'error'})
        }
    })
}

const otpFinishFirstLogin = () => {
    authStore.verifyOtpEmail(otpInput.value, username.value, newPassword.value).then(res => {
        if (res.success) {
            authStore.login(username.value, newPassword.value).then(res => {
                if (res.success == true) {
                    authStore.userAuthorized = true
                    if (systemStore.userDetail.userType.trim() == 'Partner') {
                        if (systemStore.requestedRoute.trim().length > 0) {
                            router.push({ name: systemStore.requestedRoute })
                        } else {
                            router.push({ name: 'home-partner' })
                        }
                    } else if (systemStore.userDetail.userType.trim() == 'Distributor') {
                        if (systemStore.requestedRoute.trim().length > 0) {
                            router.push({ name: systemStore.requestedRoute })
                        } else {
                            router.push({ name: 'home-distributor' })
                        }
                    }
                    else if (systemStore.userDetail.userType.trim() == 'Dell'
                        || systemStore.userDetail.userType.trim() == 'TP'
                        || systemStore.userDetail.userType.trim() == 'PAM'
                        || systemStore.userDetail.userType.trim() == 'Dell Marketing'
                        || systemStore.userDetail.userType.trim() == 'Dell'
                        || systemStore.userDetail.userType.trim() == 'TIC_Admin') {
                        if (systemStore.requestedRoute.trim().length > 0) {
                            router.push({ name: systemStore.requestedRoute })
                        } else {
                            router.push({ name: 'home-partner' })
                        }
                    }
                }
            })

        } else {
            otpInput.value = ''
        }
    })
}

const verifyOtp = () => {
    return new Promise((resolve, reject) => {
        authStore.verifyOtp(otpInput.value).then(res => {
            resolve(res)
        })
    })
}

const cancelLogin = () => {
    username.value = ''
    password.value = ''
    loginWindow.value = 'enter-credentials'
}


// const todashboard = () => {
//     if (otpSuccess.value == true) {
//         router.push({ name: 'home-partner' })
//     }
// }

const selectLanguage = (item) => {
    systemStore.selectedLanguage = item.iso.toLowerCase()
    localStorage.setItem("selectedLanguage", systemStore.selectedLanguage)
}
</script>

<style scoped>
.bg-img-container {
    background: url(../img/login-bg.jpg) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

/* Navigation list styling for accessibility - removes default list styling while maintaining semantic structure */
.navigation-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.navigation-list li {
    display: inline-block;
    margin: 0;
    padding: 0;
}
</style>
